import { Grid, List, ListItem, Typography } from "@mui/material";

export function TabsContent({ data }) {
    const listStyle = { fontSize: { xs: "0.875rem", md: "1rem" }, textAlign: "justify", padding: { xs: "4px", md: "8px" } };
    return (
        <Grid container flexDirection="column" rowGap={2} bgcolor="var(--white-gray-color)" p={2} borderRadius={5}>
            <Typography component="h3" fontSize={{ xs: "1.25rem", md: "1.5rem" }} fontWeight="bold" textAlign="center">
                {data.title}
            </Typography>
            <Typography component="p" textAlign="justify" fontSize={{ xs: "0.875rem", md: "1rem" }}>
                {data.description}
            </Typography>
            <List>
                {data.items.map(item => (
                    <ListItem sx={listStyle}>✅ {item}</ListItem>
                ))}
            </List>
        </Grid>
    );
}
